import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "family-health-history" }
const _hoisted_2 = { class: "d-flex p-2 mt-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold my-auto" }, "Family Health History", -1 /* HOISTED */)
const _hoisted_4 = {
  key: 0,
  class: "col-md-12 d-flex justify-content-center align-items-center pb-2 mt-2"
}
const _hoisted_5 = { class: "table table-responsive-md border border-gray" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-table-header" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Health Condition"),
    /*#__PURE__*/_createElementVNode("th", null, "Relationship to Patient"),
    /*#__PURE__*/_createElementVNode("th", null, "Age of Diagnosis"),
    /*#__PURE__*/_createElementVNode("th", null, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Actions")
  ])
], -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading" }, null, -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "table-empty"
}
const _hoisted_10 = ["colspan"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", null, "No Family Health History to Display", -1 /* HOISTED */)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 2,
  class: "table-error"
}
const _hoisted_14 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FamilyHistoryForm = _resolveComponent("FamilyHistoryForm")!
  const _component_ErrorMessageHandler = _resolveComponent("ErrorMessageHandler")!
  const _component_FamilyHistoryRow = _resolveComponent("FamilyHistoryRow")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (!_ctx.isAddRequested)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-primary ms-auto",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openAddFamilyHistory()))
          }, " Add Family Health History "))
        : _createCommentVNode("v-if", true)
    ]),
    (_ctx.isAddRequested)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(`card px-lg-5 py-2 mb-2 w-100 h-100 animated ${
                _ctx.isAddRequested ? 'faster fadeInDown' : 'slow fadeOutUp'
            }`)
        }, [
          _createVNode(_component_FamilyHistoryForm, {
            ref: "familyHistoryForm",
            "is-save-in-progress": _ctx.isSaving,
            "family-health-history": _ctx.familyHealthHistory,
            isEdit: false,
            "patient-relationship-enum": _ctx.patientRelationshipEnum,
            "relation-status-enum": _ctx.relationStatusEnum
          }, null, 8 /* PROPS */, ["is-save-in-progress", "family-health-history", "patient-relationship-enum", "relation-status-enum"]),
          (!_ctx.isSaving)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-primary btn-md",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancelAddFamilyHistory()))
                }, " Cancel "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary btn-md ms-2",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveFamilyHistory()))
                }, "Save"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary btn-md ms-2",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveFamilyHistory(true)))
                }, " Save and Add Another ")
              ]))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" LIST "),
    _createVNode(_component_Pagination, {
      ref: "familyPaginationInstance",
      "page-changed": _ctx.pageChangedCallback,
      "is-loading": _ctx.isLoading
    }, {
      default: _withCtx(() => [
        _createElementVNode("table", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("tbody", null, [
            _createCommentVNode(" LOADING "),
            (_ctx.isLoading)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.loadingCount, (i) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "table-loading",
                    key: i
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (i) => {
                      return (_openBlock(), _createElementBlock("td", null, _hoisted_8))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" NO RESULTS "),
            (!_ctx.isLoading && !_ctx.isError && !_ctx.hasData)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                  _createElementVNode("td", { colspan: _ctx.columns }, _hoisted_12, 8 /* PROPS */, _hoisted_10)
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" ERROR "),
            (!_ctx.isLoading && _ctx.isError)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                  _createElementVNode("td", { colspan: _ctx.columns }, [
                    _createVNode(_component_ErrorMessageHandler, {
                      title: "Family Health History",
                      "try-again": _ctx.reset
                    }, null, 8 /* PROPS */, ["try-again"])
                  ], 8 /* PROPS */, _hoisted_14)
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          (!_ctx.isLoading && !_ctx.isError && _ctx.hasData)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.page.Items, (familyHealthHistory, index) => {
                return (_openBlock(), _createBlock(_component_FamilyHistoryRow, {
                  key: index,
                  "family-health-history": familyHealthHistory,
                  columns: _ctx.columns,
                  "page-reset": _ctx.reset,
                  "patient-id": _ctx.patientId,
                  accountId: _ctx.accountId,
                  "current-edit-row-id": _ctx.currentEditRowId,
                  "onUpdate:current-edit-row-id": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentEditRowId) = $event))
                }, null, 8 /* PROPS */, ["family-health-history", "columns", "page-reset", "patient-id", "accountId", "current-edit-row-id"]))
              }), 128 /* KEYED_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["page-changed", "is-loading"])
  ]))
}